import { Spacing } from '@persona-id/design-tokens';
import styled, { css, keyframes } from 'styled-components';

import { paragraphMixins } from 'design-system/mixins/text';

interface TableProps {
  size?: 'sm' | 'md';
  isLoading?: boolean;
}

const slideKeyframes = keyframes`
  0% {
    transform: translateX(-50%) scaleX(0);
  }
  50% {
    transform: translateX(0) scaleX(1);
  }
  100% {
    transform: translateX(50%) scaleX(0);
  }
`;

const Table = styled.table.attrs({ role: 'table' })<TableProps>`
  display: table;
  width: 100%;
  border-spacing: 0;
  ${paragraphMixins.md};

  ${({ size }) =>
    size === 'sm' &&
    css`
      td,
      th {
        padding: ${Spacing[2]};
      }
    `}

  ${({ isLoading }) =>
    isLoading &&
    css`
      thead {
        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          border-bottom: 3px solid ${({ theme }) => theme.color.primary.brand};
          animation: ${slideKeyframes} 3s infinite cubic-bezier(0.5, 0, 0.5, 1);
        }
      }
    `}
`;

export default Table;
